module.exports = "<button mat-menu-item (click)=\"onOpenModalVersions()\">\n  <mat-icon>swap_horiz</mat-icon>\n  Versão\n</button>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/versions/versions-info/versions-info.component.html
// module id = ../../../../../src/app/components/versions/versions-info/versions-info.component.html
// module chunks = main